import React from 'react';
import { useState } from 'react';
import styles from './Images.module.scss';

const Images = ({ images }) => {
  const [activeImageNum, setCurrent] = useState(0);
  const length = images.length;
  const nextSlide = () => {
    setCurrent(activeImageNum === length - 1 ? 0 : activeImageNum + 1);
  };
  const prevSlide = () => {
    setCurrent(activeImageNum === 0 ? length - 1 : activeImageNum - 1);
  };
  if (!Array.isArray(images) || images.length <= 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <section className={styles.slider}>
        {images.length > 1 && (
          <div className={styles.nav}>
            <button onClick={prevSlide} className={styles.left}>
              <svg
                width="21"
                height="30"
                viewBox="0 0 21 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_317_1454)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.0003 10.9127L5.00021 10.9128L5.70732 11.6199L5.7074 11.6198L14.9128 20.8253L15.62 20.1182L6.41451 10.9127L15.6201 1.70711L14.913 1L5.7074 10.2056L5.70716 10.2054L5.00005 10.9125L5.0003 10.9127Z"
                    fill="white"
                  />
                  <path
                    d="M5.00021 10.9128L4.64666 10.5592C4.4514 10.7545 4.4514 11.0711 4.64666 11.2664L5.00021 10.9128ZM5.0003 10.9127L5.35385 11.2663C5.54911 11.071 5.54911 10.7544 5.35385 10.5592L5.0003 10.9127ZM5.70732 11.6199L5.35377 11.9735C5.54903 12.1687 5.86561 12.1687 6.06087 11.9735L5.70732 11.6199ZM5.7074 11.6198L6.06096 11.2663C5.96719 11.1725 5.84001 11.1198 5.7074 11.1198C5.57479 11.1198 5.44762 11.1725 5.35385 11.2663L5.7074 11.6198ZM14.9128 20.8253L14.5593 21.1788C14.6531 21.2726 14.7802 21.3253 14.9128 21.3253C15.0455 21.3253 15.1726 21.2726 15.2664 21.1788L14.9128 20.8253ZM15.62 20.1182L15.9735 20.4717C16.1688 20.2764 16.1688 19.9599 15.9735 19.7646L15.62 20.1182ZM6.41451 10.9127L6.06096 10.5592C5.96719 10.6529 5.91451 10.7801 5.91451 10.9127C5.91451 11.0453 5.96719 11.1725 6.06096 11.2663L6.41451 10.9127ZM15.6201 1.70711L15.9737 2.06066C16.0674 1.96689 16.1201 1.83972 16.1201 1.70711C16.1201 1.5745 16.0674 1.44732 15.9737 1.35355L15.6201 1.70711ZM14.913 1L15.2666 0.646447C15.1728 0.552678 15.0456 0.5 14.913 0.5C14.7804 0.5 14.6532 0.552678 14.5595 0.646447L14.913 1ZM5.7074 10.2056L5.35385 10.5592C5.44762 10.6529 5.57479 10.7056 5.7074 10.7056C5.84001 10.7056 5.96719 10.6529 6.06096 10.5592L5.7074 10.2056ZM5.70716 10.2054L6.06071 9.85181C5.86545 9.65654 5.54886 9.65654 5.3536 9.85181L5.70716 10.2054ZM5.00005 10.9125L4.64649 10.5589C4.45123 10.7542 4.45123 11.0708 4.64649 11.266L5.00005 10.9125ZM5.35377 11.2664L5.35385 11.2663L4.64674 10.5592L4.64666 10.5592L5.35377 11.2664ZM6.06087 11.2663L5.35377 10.5592L4.64666 11.2664L5.35377 11.9735L6.06087 11.2663ZM5.35385 11.2663L5.35377 11.2663L6.06087 11.9735L6.06096 11.9734L5.35385 11.2663ZM15.2664 20.4717L6.06096 11.2663L5.35385 11.9734L14.5593 21.1788L15.2664 20.4717ZM15.2664 19.7646L14.5593 20.4717L15.2664 21.1788L15.9735 20.4717L15.2664 19.7646ZM6.06096 11.2663L15.2664 20.4717L15.9735 19.7646L6.76806 10.5592L6.06096 11.2663ZM15.2666 1.35355L6.06096 10.5592L6.76806 11.2663L15.9737 2.06066L15.2666 1.35355ZM14.5595 1.35355L15.2666 2.06066L15.9737 1.35355L15.2666 0.646447L14.5595 1.35355ZM6.06096 10.5592L15.2666 1.35355L14.5595 0.646447L5.35385 9.85205L6.06096 10.5592ZM5.3536 10.5589L5.35385 10.5592L6.06096 9.85205L6.06071 9.85181L5.3536 10.5589ZM5.3536 11.266L6.06071 10.5589L5.3536 9.85181L4.64649 10.5589L5.3536 11.266ZM5.35385 10.5592L5.3536 10.5589L4.64649 11.266L4.64674 11.2663L5.35385 10.5592Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_317_1454"
                    x="0.5"
                    y="0.5"
                    width="19.6201"
                    height="28.8253"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_317_1454"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_317_1454"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
            <button onClick={nextSlide} className={styles.right}>
              <svg
                width="21"
                height="30"
                viewBox="0 0 21 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_317_1451)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.6198 10.9125L15.6199 10.9125L14.9128 10.2054L14.9127 10.2054L5.70727 0.999992L5.00016 1.7071L14.2056 10.9125L5 20.1181L5.70711 20.8253L14.9127 11.6196L14.913 11.6199L15.6201 10.9128L15.6198 10.9125Z"
                    fill="white"
                  />
                  <path
                    d="M15.6199 10.9125L15.9735 11.266C16.1687 11.0708 16.1687 10.7542 15.9735 10.5589L15.6199 10.9125ZM15.6198 10.9125L15.2663 10.559C15.071 10.7543 15.071 11.0708 15.2663 11.2661L15.6198 10.9125ZM14.9128 10.2054L15.2664 9.8518C15.0711 9.65654 14.7545 9.65654 14.5592 9.8518L14.9128 10.2054ZM14.9127 10.2054L14.5592 10.559C14.6529 10.6528 14.7801 10.7054 14.9127 10.7054C15.0453 10.7054 15.1725 10.6528 15.2663 10.559L14.9127 10.2054ZM5.70727 0.999992L6.06082 0.646439C5.96706 0.552671 5.83988 0.499992 5.70727 0.499992C5.57466 0.499992 5.44749 0.552671 5.35372 0.646439L5.70727 0.999992ZM5.00016 1.7071L4.64661 1.35355C4.45135 1.54881 4.45135 1.86539 4.64661 2.06065L5.00016 1.7071ZM14.2056 10.9125L14.5592 11.2661C14.6529 11.1723 14.7056 11.0452 14.7056 10.9125C14.7056 10.7799 14.6529 10.6528 14.5592 10.559L14.2056 10.9125ZM5 20.1181L4.64645 19.7646C4.55268 19.8584 4.5 19.9855 4.5 20.1181C4.5 20.2508 4.55268 20.3779 4.64645 20.4717L5 20.1181ZM5.70711 20.8253L5.35355 21.1788C5.44732 21.2726 5.5745 21.3253 5.70711 21.3253C5.83972 21.3253 5.96689 21.2726 6.06066 21.1788L5.70711 20.8253ZM14.9127 11.6196L15.2663 11.2661C15.1725 11.1723 15.0453 11.1196 14.9127 11.1196C14.7801 11.1196 14.6529 11.1723 14.5592 11.2661L14.9127 11.6196ZM14.913 11.6199L14.5594 11.9735C14.7547 12.1687 15.0713 12.1687 15.2665 11.9735L14.913 11.6199ZM15.6201 10.9128L15.9736 11.2663C16.1689 11.0711 16.1689 10.7545 15.9736 10.5592L15.6201 10.9128ZM15.2663 10.5589L15.2663 10.559L15.9734 11.2661L15.9735 11.266L15.2663 10.5589ZM14.5592 10.5589L15.2663 11.266L15.9735 10.5589L15.2664 9.8518L14.5592 10.5589ZM15.2663 10.559L15.2664 10.5589L14.5592 9.8518L14.5592 9.85188L15.2663 10.559ZM5.35372 1.35355L14.5592 10.559L15.2663 9.85188L6.06082 0.646439L5.35372 1.35355ZM5.35372 2.06065L6.06083 1.35355L5.35372 0.646439L4.64661 1.35355L5.35372 2.06065ZM14.5592 10.559L5.35372 1.35355L4.64661 2.06065L13.8521 11.2661L14.5592 10.559ZM5.35355 20.4717L14.5592 11.2661L13.8521 10.559L4.64645 19.7646L5.35355 20.4717ZM6.06066 20.4717L5.35355 19.7646L4.64645 20.4717L5.35355 21.1788L6.06066 20.4717ZM14.5592 11.2661L5.35355 20.4717L6.06066 21.1788L15.2663 11.9732L14.5592 11.2661ZM15.2665 11.2663L15.2663 11.2661L14.5592 11.9732L14.5594 11.9735L15.2665 11.2663ZM15.2665 10.5592L14.5594 11.2663L15.2665 11.9735L15.9736 11.2663L15.2665 10.5592ZM15.2663 11.2661L15.2665 11.2663L15.9736 10.5592L15.9734 10.559L15.2663 11.2661Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_317_1451"
                    x="0.5"
                    y="0.5"
                    width="19.6201"
                    height="28.8253"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_317_1451"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_317_1451"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
          </div>
        )}
        {/* <div className={styles.currentimagenav}>
          {images.length > 1 &&
            images.map((item, index) => (
              <button
                className={index === 0 && styles.active}
                key={index}
              ></button>
            ))}
        </div> */}
        {images.map((currentSlide, index) => {
          if (images.length > 1) {
            return (
              <div
                className={
                  index === activeImageNum
                    ? styles.currentslideactive
                    : styles.currentslide
                }
                key={index}
              >
                {index === activeImageNum && (
                  <img
                    className={styles.img}
                    src={currentSlide.url}
                    alt={currentSlide.alttext}
                  />
                )}
              </div>
            );
          } else {
            return (
              <div className={styles.currentslideactive} key={index}>
                <img
                  className={styles.img}
                  src={currentSlide.url}
                  alt={currentSlide.alttext}
                />
              </div>
            );
          }
        })}
      </section>
    </div>
  );
};

export default Images;
